import HargaKubikasiKayu from './HargaKubikasiKayu';

export default HargaKubikasiKayu;
